import * as fromRoot from '../../reducers';
import * as ZonesReducer from './zones.reducer';
import * as ZonesSubscriptionsReducer from './zones-subscriptions.reducer';
import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import * as ZonesSubscriptionGroupsReducer from '../reducers/zones-subscription-groups.reducer';


export interface ZonesState {
  zone: ZonesReducer.State;
  zonesSubscriptions: ZonesSubscriptionsReducer.State;
  zoneSubscriptionGroups: ZonesSubscriptionGroupsReducer.State;
}

export interface State extends fromRoot.State {
  zones: ZonesState;
}

export const reducers: ActionReducerMap<ZonesState, Action> = {
  zone: ZonesReducer.reducer,
  zonesSubscriptions: ZonesSubscriptionsReducer.reducer,
  zoneSubscriptionGroups: ZonesSubscriptionGroupsReducer.reducer
};

export const selectZonesState = createFeatureSelector<State, ZonesState>('zones');
export const selectZoneState = createSelector(selectZonesState, (state: ZonesState) => state.zone);
export const selectZonesSubscriptionsState = createSelector(selectZonesState, (state: ZonesState) => state.zonesSubscriptions);

export const selectZoneSubscriptionGroupsState = createSelector(selectZonesState, (state: ZonesState) => state.zoneSubscriptionGroups);

export const getDrawChangeMode = createSelector(selectZoneState, ZonesReducer.getDrawChangeMode);
export const getHighlightedZone = createSelector(selectZoneState, ZonesReducer.getHighlightedZone);
export const getZoneVisibility = createSelector(selectZoneState, ZonesReducer.getZoneVisibility);
export const getLastMode = createSelector(selectZoneState, ZonesReducer.getLastMode);

export const getZonesSubscriptions = createSelector(selectZonesSubscriptionsState, ZonesSubscriptionsReducer.getZonesSubscriptions);
export const getZonesSubscriptionById = createSelector(selectZonesSubscriptionsState, ZonesSubscriptionsReducer.getZonesSubscriptionById);
export const getZoneNextNumber = createSelector(getZonesSubscriptions, (zones: ZoneSubscription[], zoneType) => zones?.filter(zone => zone.zoneType === zoneType)?.length + 1);

export const getZoneSubscriptionGroups = createSelector(selectZoneSubscriptionGroupsState, ZonesSubscriptionGroupsReducer.getZonesSubscriptionGroups);
export const getZonesSubscriptionGroupById = createSelector(selectZoneSubscriptionGroupsState, ZonesSubscriptionGroupsReducer.getZonesSubscriptionGroupById);



